import { black } from '@src/support/colors';
import { rgba } from '@src/support/rgba';

export const boxShadow = `${rgba(black, 0.05)} 0.125em 0.125em 0 0`;
